import { authRoles } from 'app/auth';
import RelacioanalizisesKerdesTable from 'app/admin/relacioanaliziseskerdes/table/RelacioanalizisesKerdesTable';
import RelacioanalizisesKerdesEditForm from 'app/admin/relacioanaliziseskerdes/editform/RelacioanalizisesKerdesEditForm';

export default [
	{
		path: '/relacioanaliziseskerdes/edit/:id',
		component: RelacioanalizisesKerdesEditForm,
		auth: authRoles.admin
	},
	{
		path: '/relacioanaliziseskerdes/:sessionNameParam?',
		component: RelacioanalizisesKerdesTable,
		auth: authRoles.admin
	}
];
